<template>
  <div class="login" style="padding:0;height:100%">
    <div style="position:relative;height:100%">
      <div
        class="title"
        style="width:580px;position:absolute;height:343px;top:50%;left:150px;transform:translateY(-50%)"
      >
        <img src="~@/assets/chat.png" style="width:500px;height:343px" />
      </div>
      <div
        style="padding:60px 40px;width:443px;height:450px;background:#fff;border-radius:2px;position:absolute;right:160px;top:50%;transform:translateY(-50%)"
      >
        <!--<div style="position: absolute;left: 50%;top: 0;transform: translateX(-50%);">-->
        <div style="margin-bottom:40px;text-align: center">
          <span style="display: inline-block;width:43px;height:30px;margin-right:13px">
            <img src="~@/assets/lo.svg" style="width:100%;height:100%" />
          </span>
          <span
            style="display: inline-block;vertical-align: top;color:#000;font-size:23px;line-height:32px;font-weight: bold"
          >
            帮扶业务信息系统
          </span>
        </div>
        <a-form :form="form" @submit="handleSubmit">
          <!-- <a-alert
            v-if="isLoginError"
            type="error"
            showIcon
            style="margin-bottom: 24px;"
            message="账户或密码错误"
          /> -->
          <a-col span="24">
            <a-form-item
              label="用户名"
              :label-col="{ style: { width: '70px' } }"
              :wrapper-col="{ style: { width: `calc(100% - 70px )` } }"
            >
              <a-input
                v-decorator="[
                  'userName',
                  { rules: [{ required: true, message: '请输入用户名!' }] }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col span="24">
            <a-form-item
              label="密码"
              :label-col="{ style: { width: '70px' } }"
              :wrapper-col="{ style: { width: `calc(100% - 70px )` } }"
            >
              <a-input-password
                v-decorator="['passWord', { rules: [{ required: true, message: '请输入密码!' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col span="16">
            <a-form-item
              label="验证码"
              :label-col="{ style: { width: '70px' } }"
              :wrapper-col="{ style: { width: `calc(100% - 70px )` } }"
            >
              <a-input
                v-decorator="['code', { rules: [{ required: true, message: '请输入验证码!' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col span="8">
            <div style="text-align: right">
              <img :src="this.checkInfo.img" style="cursor: pointer" @click="changeImg" />
            </div>
          </a-col>
          <a-col span="24" class="button">
            <a-form-item :wrapper-col="{ style: { width: `calc(100% - 70px )` } }">
              <a-button
                type="primary"
                html-type="submit"
                style="width:100%;"
                :loading="loginBtn"
                :disabled="loginBtn"
              >
                登录
              </a-button>
            </a-form-item>
          </a-col>
        </a-form>
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
// import md5 from 'md5'
import { JSEncrypt } from 'jsencrypt'
import { mapActions } from 'vuex'
import store from '@/store'
import router from '@/router'
import { getCode } from '@/api/login'
export default {
  name: 'Index',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'coordinated' }),
      loginBtn: false, // 按钮liading状态
      isLoginError: false, // 是否展示用户名或密码错误
      checkInfo: {} // 验证码信息
    }
  },
  mounted() {
    this.getCode() // 获取验证码信息
  },
  methods: {
    ...mapActions(['Login', 'Logout']), // vuex中的登陆退出接口方法
    handleSubmit(e) {
      // 提交登陆
      e.preventDefault()
      this.loginBtn = true
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log(values)
          const Encrypt = new JSEncrypt() // rea加密
          // 加密
          // 加密一个参数公钥
          const publicKey =
            'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCBDpSeXubyRUjMHkyqdsVhOIoqHOku+emZOReus3+NbXP2YRerJVuBR7SkMCLVBaxMEgjsBb0os2NXGS0/t1TCUgbu5nuWTBO/fBygMKt1zkVDashWQAtAfE6ZE5VB6RDgzWRd7ZySBjcjKV2sz04l0/wxtevVAyR633o7p9c1xQIDAQAB'
          Encrypt.setPublicKey(publicKey)
          const data = { ...values, ...this.checkInfo }
          data.passWord = Encrypt.encrypt(data.passWord)
          this.Login(data)
            .then((res) => this.loginSuccess(res)) // 登陆成功
            .catch((err) => this.requestFailed(err)) // 登陆失败
            .finally(() => {
              this.loginBtn = false
            })
          // data.passWord = md5(values.passWord)
          //   console.log(values, data)
        } else {
          setTimeout(() => {
            this.loginBtn = false
          }, 600)
        }
      })
    },
    // 登陆成功
    loginSuccess(res) {
      const permission = res.user.user_permissions || []
      // const permission = ['aggregate', 'itemAssit', 'caseAssit', 'giveMe', 'assitTarget', 'fundMange', 'sendMange', 'contentMange', 'systemPerson', 'volunteerMange']
      store.dispatch('GenerateRoutes', { roles: permission }).then(() => {
        // 暂时将角色写死，实际应该根据后台传过来的角色信息
        router.addRoutes(store.getters.addRouters)
        // console.log(this.$router)
        // this.$router.push({ path: '/' })
        this.$router.push({ path: '/assit/personal' })
      })
      // console.log(router)
      // this.$router.push({ path: '/' })
      // 延迟 1 秒显示欢迎信息
      // setTimeout(() => {
      //   this.$notification.success({
      //     message: '欢迎',
      //     description: `${timeFix()}，欢迎回来`
      //   })
      // }, 1000)
      this.isLoginError = false
    },
    // 登陆失败
    requestFailed() {
      this.isLoginError = true
      this.getCode() // 刷新验证码
      // this.$notification['error']({
      //   message: '错误',
      //   description: ((err.response || {}).data || {}).message || '请求出现错误，请稍后再试',
      //   duration: 4
      // })
    },
    // 获取验证码信息
    getCode() {
      this.checkInfo = {}
      getCode().then((response) => {
        this.checkInfo = response
      })
    },
    changeImg() {
      this.getCode()
    }
  }
}
</script>

<style scoped lang="less">
.login {
  /deep/.ant-col.ant-form-item-label {
    float: left;
  }
  /deep/ .ant-col.ant-form-item-control-wrapper {
    float: left;
  }
  .button {
    /deep/ .ant-col.ant-form-item-control-wrapper {
      float: left;
      margin-left: 70px;
    }
  }
  /*background: url('/src/assets/bg.png');*/
}
</style>
